import React from "react";
import BtnNav from "./BtnNav";
import { FcDocument } from "react-icons/fc";
import { BsFillPersonFill } from "react-icons/bs";
import { BiLogOut } from "react-icons/bi";
import { IoDocumentAttachOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Navigation = () => {
  const user = JSON.parse(window?.localStorage.getItem("userData") ?? "{}");
  //const user = window.localStorage.getItem("userData");
  console.log(user?.roles, "roles");
  const navigate = useNavigate();
  const profile = "mon-profile/" + user?.email;

  return (
    <>
      {user && user?.id && user.roles != "CLIENT" && (
        <BtnNav
          titre={<span className="btn-nav-name">Liste des demandes</span>}
          icone={<IoDocumentAttachOutline />}
          lien="list-des-demandes"
        />
      )}

      {user && user?.id && (
        <BtnNav
          titre={<span className="btn-nav-name">Mon profile</span>}
          icone={<BsFillPersonFill />}
          lien={profile}
        />
      )}

      {user && user?.id && (
        <button
          class="btn text-start btn-navigation btn-link w-100 pb-0 mt-2"
          type="button"
          onClick={() => {
            window.localStorage.clear();
            navigate("/login");
          }}
        >
          <BiLogOut /> <span className="btn-nav-name">{"Se déconnecter"}</span>
        </button>
      )}
    </>
  );
};

export default Navigation;
